module.exports = __webpack_public_path__ + "static/media/ckn_platillo_nuevo.6d189825.jpg";